import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { EVENT_INITIATORS, INTERACTION_TYPES } from '@zocdoc/frontend-metrics';
import { Modal } from '@zocdoc-frontend-common/components-modal';
import { withCustomMetrics } from '@zocdoc/frontend-metrics';

import { ModalContent } from '../../components/ModalContent';
import { MODAL_STRINGS } from '../../components/ModalContent/constants.js';

class ModalContainer extends Component {
    static propTypes = {
        modalContent: PropTypes.object,
        sendMetric: PropTypes.func,
    };

    componentDidMount() {
        if (
            this.props.modalContent.headerText ===
                MODAL_STRINGS.MaximumVaccineAppointmentHeaderDose1 ||
            this.props.modalContent.headerText ===
                MODAL_STRINGS.MaximumVaccineAppointmentHeaderDose2
        ) {
            this.props.sendMetric({
                action: 'View vaccine fraud modal',
                initiator: EVENT_INITIATORS.USER,
                interactionType: INTERACTION_TYPES.VIEW,
                component: 'Vaccine Fraud Modal',
                element: 'Error',
            });
        }
    }

    render() {
        return (
            <Modal showCloseIcon={false}>
                <ModalContent {...this.props.modalContent} />
            </Modal>
        );
    }
}

export default withCustomMetrics({
    page: 'Booking',
    category: 'Booking - Appt Info',
})(ModalContainer);
